import React, { useEffect, useState } from 'react';
import ReporteeSelectView from "./reportee-select.view";
import { IReporteeList, IReporteeSelectProps } from "./type/reportee-select.types";
import { fetchReporteeList, viewMapper } from "./action/reportee-select.action";


const ReporteeSelect: React.FC<IReporteeSelectProps> = (props) => {
    const maxItems = 50;
    const [list, setList] = useState<IReporteeList[]>([]);
    const [selectedReporteeId, setSelectedReporteeId] = useState<string>('')
    const [paginationControl, setPaginationControl] = useState({
        pageNumber: 0,
        pageSize: 20,
        hasNext: false,
        hasPrevious:false,
    });
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        loadData();
    }, []);

    async function loadData() {
        const res = await fetchReporteeList(props.supervisorId, paginationControl.pageNumber, paginationControl.pageSize);
        const formattedRes = viewMapper(res);
        setList(formattedRes);
    }

    async function loadNextData() {
        setIsLoading(true);
        const nextPageNumber = paginationControl.pageNumber + 1;
        try {
            const res = await fetchReporteeList(props.supervisorId, nextPageNumber, paginationControl.pageSize);
            let merged = [...list, ...res];
            let uniqueEmployees = Array.from(
                new Map(merged.map((emp: any) => [emp.id, emp])).values()
            );
            // if docs length is more than maxItems then keep latest items
            if (uniqueEmployees.length > maxItems) {
                uniqueEmployees = uniqueEmployees.slice(uniqueEmployees.length - maxItems);
            }
            setPaginationControl((prev) => ({
                ...prev,
                hasNext: res.length === paginationControl.pageSize,
                pageNumber: nextPageNumber
            }));
            setList(uniqueEmployees);
        } catch (e) {
            console.log('error encountered', e)
        } finally {
            setIsLoading(false);
        }
    }


    async function loadPrevData() {
        setIsLoading(true);
        const prevPageNumber = paginationControl.pageNumber - 1;
        if (prevPageNumber < 0 ) {
            setPaginationControl((prev)=>({
                ...prev,
                hasPrevious: false
            }))
            return;
        }
        try {
            const res = await fetchReporteeList(props.supervisorId, prevPageNumber, paginationControl.pageSize);
            let merged = [...res,...list];
            let uniqueEmployees = Array.from(
                new Map(merged.map((emp: any) => [emp.id, emp])).values()
            );
            // if docs length is more than maxItems then keep latest items
            if (uniqueEmployees.length > maxItems) {
                uniqueEmployees = uniqueEmployees.slice(uniqueEmployees.length - maxItems);
            }
            setPaginationControl((prev) => ({
                ...prev,
                hasPrevious: res.length === paginationControl.pageSize,
                pageNumber: prevPageNumber
            }));
            setList(uniqueEmployees);
        } catch (e) {
            console.log('error encountered', e)
        } finally {
            setIsLoading(false);
        }
    }


    function onReporteeChange(id: string) {
        setSelectedReporteeId(id);
        props.onChange?.(id);

    }


    return (
        <ReporteeSelectView
            list={list}
            value={props.value}
            onChange={onReporteeChange}
            includeAllEmployeeOption={props.includeAllSelectOption}
            placeholder={props.placeholder}
            selectedId={selectedReporteeId}
            paginationControls={{
                isLoading: isLoading,
                loadNext: loadNextData,
                loadPrev: loadPrevData,
                hasNext: paginationControl.hasNext,
                hasPrevious: paginationControl.hasPrevious
            }}
        />
    )


}
export default ReporteeSelect
